// Tiny cookie helper. Avoids adding `js-cookie` (~4 KB) for the handful of
// reads/writes the usage gate needs. Limited to the subset we use:
// document.cookie, name=value, expires (days), path=/, SameSite=Lax.
// Mirrors the performance-calculator's utils/cookies.js.

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.split('; ').find(row => row.startsWith(name + '='));
  if (!match) return null;
  const raw = match.split('=').slice(1).join('=');
  try {
    return decodeURIComponent(raw);
  } catch {
    // Malformed percent-encoding (a cookie written by something other than
    // this SPA) must never throw through the gate's fail-open paths —
    // return the raw value instead.
    return raw;
  }
}

export function setCookie(name: string, value: string, days = 365): void {
  if (typeof document === 'undefined') return;
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax; Secure`;
}
